import React, { useRef, useLayoutEffect, forwardRef, useCallback } from 'react';
import TextareaAutosizeDep from 'react-textarea-autosize';
import { Controller } from 'react-hook-form';

const TextareaAutosize = forwardRef((props, forwardedRef) => {
  // RHF mode: when control + name are provided, wrap in Controller
  if (props.control && props.name) {
    const { control, name, ...rest } = props;
    return (
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <TextareaAutosize
            id={field.name}
            name={field.name}
            value={field.value ?? ''}
            onChange={(event) => field.onChange(event.target.value)}
            {...rest}
          />
        )}
      />
    );
  }
  const internalRef = useRef(null);
  const cursorPositionRef = useRef(null);

  // Combine refs properly
  const setRefs = useCallback(
    (node) => {
      internalRef.current = node;

      if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      } else if (forwardedRef) {
        forwardedRef.current = node;
      }
    },
    [forwardedRef],
  );

  const { onChange, value, ...otherProps } = props;

  const handleChange = (event) => {
    if (event.target.selectionStart !== null) {
      cursorPositionRef.current = event.target.selectionStart;
    }

    if (onChange) {
      onChange(event);
    }
  };

  useLayoutEffect(() => {
    const textarea = internalRef.current;

    if (textarea && cursorPositionRef.current !== null && document.activeElement === textarea) {
      const position = cursorPositionRef.current;
      textarea.setSelectionRange(position, position);
    }
  }, [value]);

  return (
    <div className="textarea-autosize-wrapper" style={{ position: 'relative', width: '100%' }}>
      <TextareaAutosizeDep {...otherProps} ref={setRefs} value={value} onChange={handleChange} />
    </div>
  );
});

TextareaAutosize.displayName = 'TextareaAutosize';

export default TextareaAutosize;
